import React from "react";
import { Link } from "react-router-dom";
import error404 from "../assets/icon/error404.svg";

export default function ErrorPage() {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h1>!Oops... Page not found</h1>
        <img src={error404} alt="" className="" />
      </div>
      <h1>Go back to Home</h1>
      <Link to="/">Home</Link>
    </div>
  );
}
